import { useAppContext } from "../../layout/layout";

import Wrapper from "./theme-component.styles";

const Theme = () => {
  const { isDarkTheme, toggleTheme } = useAppContext();
  return (
    <Wrapper onClick={toggleTheme}>
      {isDarkTheme ? (
        <img src="./assets/icons/day.svg" alt="light icon" className="dark" />
      ) : (
        <img src="./assets/icons/night.svg" alt="light icon" />
      )}
    </Wrapper>
  );
};
export default Theme;
